import React from "react";
import styled from "styled-components";
import { ProtectedPageContext } from "../../pages/_contexts/ProtectedPageContext";
import { getIconName, iconName } from "../icons/Icons";

import { TooltipTheOneWrapper } from "../TooltipTheOne";

import { IconWrapper, Styled2Button } from "../styles/button2Styles";
import { ButtonSize, buttonStyling, ButtonVariant } from "./Shared";


type LinkButtonProps = {
    variant:ButtonVariant;
    disabled?: boolean;
    size?:ButtonSize;
    download?:string;
    icon?: iconName;
    iconPosition?: 'left' | 'right';
    text?: string;
    href:string;
    target?:'_blank'|'_self'|'_parent'|'_top';
    rel?:string;
    tooltipContent?:React.ReactNode;
    tooltipHorizontalAlignment?: 'left' | 'right';
    onClick?:()=>void;
}


export function LinkButton(props: LinkButtonProps): JSX.Element {

    const colors = React.useContext(ProtectedPageContext).colors;
    const buttonStyles = buttonStyling(colors).handleButtonBorder;
    // const variantStyles = buttonStyles.variants[props.variant].border;

    const isDisabled = props.disabled !== undefined && props.disabled === true;
    const target = props.target || '_self';

    const btn = <LinkButtonWrapper 
            variant={props.variant}
            icon={props.icon} 
            iconPosition={props.iconPosition}
            hasText={!!props.text}
            borderRadius="4px"
            size={props.size}
            disabled={props.disabled} 
            href={isDisabled ? undefined : props.href}
            target={isDisabled ? undefined : target}
            role={isDisabled ? 'link' : undefined}
            aria-disabled={isDisabled ? 'true' : 'false'}
            download={props.download || undefined}
            rel={props.rel}>
            {props.icon && (
                <IconWrapper variant={props.variant}>{getIconName(props.icon)}</IconWrapper>
            )}
            {props.text && (
                <span>{props.text}</span>
            )}
            {/* <ButtonHover variant={props.variant}></ButtonHover> */}
        </LinkButtonWrapper>;


    return props.tooltipContent 
        ?   <TooltipTheOneWrapper tooltipContent={props.tooltipContent} horizontalAlignment={props.tooltipHorizontalAlignment}>
                {btn}
            </TooltipTheOneWrapper>
        : btn
}

const LinkButtonWrapper = styled.a<{ 
    variant: ButtonVariant, 
    icon?: iconName, 
    iconPosition?: 'left' | 'right', 
    hasText?: boolean, 
    borderRadius: string, 
    size?: ButtonSize,
    disabled?: boolean }>
    `
    ${Styled2Button}
    
`